<template>
    <button type="button" class="add-text-btn" @click="$emit('click')">
        <v-icon size="16" class="add-text-icon">{{ icon }}</v-icon>
        <span>{{ label }}</span>
    </button>
</template>

<script>
export default {
    name: "AddTextButton",
    props: {
        label: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: 'mdi-plus-circle-outline',
        },
    },
}
</script>

<style scoped>
.add-text-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 40px;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px;
    font-weight: 600;
    color: var(--v-accent-base);
}

.theme--dark .add-text-btn {
    color: var(--v-primary-base);
}

.add-text-icon {
    color: inherit !important;
}
</style>
